import { IState } from 'legacy/lut/store'

export const selectExtendedPartnerData = (state: IState) => state.extendedPartnerData
